/**
 * Created by idea on 03/07/2017.
 */
import { Component } from '@angular/core';

declare var jQuery: any;

@Component({
  selector: 'basic',
  templateUrl: 'basic.template.html',
})
export class basicComponent {
  constructor() {}
}



// WEBPACK FOOTER //
// ./src/app/layout/layouts/basic.component.ts